import { createFileRoute } from "@tanstack/react-router";

import { CampaignPage } from "@/features/growth/pages";

export const Route = createFileRoute("/_app/growth/campaigns/$campaignId")({
  component: Campaign,
});

function Campaign() {
  const { campaignId } = Route.useParams();
  return <CampaignPage key={campaignId} campaignId={campaignId} />;
}
